<template>
    <div class="content">
    <!--头部-->
     <div style="overflow: hidden">
      <help-head></help-head>
     </div>
  <!--面包屑-->
     <div class="crumb">
        <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
          <span>关于</span>
     </div>
     <div class="cont">
         <div class="cont-head">
          <img src="../../../../static/image/icon.png" class="img"/>
           <h1 class="cont-title">远程教学系统</h1>
          <div class="verinfor">
          <a href="javascript:;" class="verinfor-btn s-btn" @click="verinfor">版本记录</a>

          </div>
         </div>
         <div class="cont-message">
           <p>版本号：V2.0.2</p>
           <p>联系电话：400-0571-574</p>
           <p>联系地址：杭州市上城区中河中路198号绿都大厦4F、5F</p>
           <p>Copyright © Hangzhou Lianzhong Medical Science Co., Ltd.</p>
         </div>
     </div>
     <div class="dialog">
      <el-dialog
        title="版本记录"
        :visible.sync="centerDialogVisible"
        width="50%"
        center>
          <p class="text"><strong style="font-weight :bolder">V2.0.2</strong></p>
          <p class="text">2019年4月14号</p>
          <P class="text_ver">-专题读片与教学管理的列表操作中增加通过二维码进入会议与课程的功能。</P>
          <p class="text_ver">-新增首页的界面的显示功能。</p>
          <p class="text_ver">-新增消息框提示功能。</p>
          <p class="text"><strong style="font-weight :bolder">V2.0.1</strong></p>
          <p class="text">2019年1月14号</p>
          <P class="text_ver">-涉及【附件】【病例资料】【影像】的界面增加对应数量展示优化。</P>
          <p class="text_ver">-新增帮助和关于的显示功能。</p>
          <p class="text"><strong style="font-weight :bolder">V2.0.0</strong></p>
          <p class="text">2018年11月20号</p>
          <p class="text_ver">-涉及历史检查阅片中支持多个阅片功能的优化。</p>
          <p class="text"><strong style="font-weight :bolder">V1.0.1</strong></p>
          <p class="text">2018年6月15号</p>
          <p class="text_ver">-新增专题读片，教学中心和教学管理功能模块。</p>
          <p class="text"><strong style="font-weight :bolder">V1.0.0</strong></p>
          <p class="text">2018年4月20号</p>
          <p class="text_ver">-新增资料中心，每日读片和典型病例库功能模块。</p>
     </el-dialog>
     </div>
     </div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  export default {
    data () {
      return {
         height:'',
         centerDialogVisible: false
      }
    },
    components:{
        helpHead,
    },
  methods:{
    verinfor(){
      this.show=true
      this.centerDialogVisible = true
    },
  }
}

</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
 .crumb
 line-height: 30px
 margin: 5px 0  0 20px
.cont
 width:50%
 height:70%
 background:#fff
 margin: 0 auto
 .cont-head
  height: 100px
  line-height:100px
  border-bottom: 1px solid #cccccc
  .img
   margin:20px 30px 0px 50px
   float: left
  .cont-title
    float: left
    font-size 42px
    font-weight: bolder
    color: #000
  .verinfor
      float: right
      width: 80px
      height: 36px
      line-height: 36px
      background:#00abad
      text-align: center
      border-radius: 4px
      margin:35px 30px 0px 0px
   .verinfor-btn
      color:#fff
 .cont-message
     height:50px
     line-height:50px
     color:#000
     font-size: 16px
     margin:50px 0px 0px 60px
.text
    line-height:40px
.text_ver
   line-height:24px
</style>



// WEBPACK FOOTER //
// about.vue?9888097e